<template>
  <div :id="`${id}`" 
    :class="{
      'multiselectlist': true
    }">  
    <div class="multiselectlist__inner">
      <h3 class="multiselectlist__header" @click.prevent="onClickSelections()">
        <span class="multiselectlist__header-text">Selected Items</span>
        <span class="multiselectlist__header-count">{{selections.length}}</span>
      </h3>
      <div class="multiselectlist__content">
        <p class="multiselectlist__items">
          <span v-for="(selection) in selections" :key="selection.siteId" class="newline">
            <strong>{{selection.siteDescription}}</strong> ({{selection.siteCode}}): {{selection.subDescription}}               
          </span>
        </p>
        <div class="multiselectlist__buttons">
          <button
            :id="`${id}_clearbutton`"
            type="button"
            class="button multiselectlist__clearbutton"
            title="Clear Selection"
            aria-label="Clear Selection"
            :disabled="disabled"
            @click.prevent="onClearButton()">
            <span class="ui-button-text">Clear Selection</span>
          </button>
          <button
            :id="`${id}_addbutton`"
            type="button"
            class="button primary multiselectlist__addbutton"
            title="Add To Cart"
            aria-label="Add To Cart"
            :disabled="disabled"
            @click.prevent="onAddButton()">
            <span class="ui-button-text">Add To Cart</span>
          </button>                                        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mutations } from "@/store/types";

export default {
  name: "MultiSelectListComponent",
  props: {
    id: String,
    value: Array,
    error: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      selections: []
    }
  },
  created() {
  },
  watch: {
    value() {
      if (this.value !== this.selections) {
        this.selections = this.value;
      }

      this.updateSelectionDisplay(); 
    }
  },
  methods: {  
    updateSelectionDisplay() {
      if (this.selections.length !== 0) {
        this.removeClass("multiselectlist--state-enabled");
        this.setDisplay("flex");
      } else {
        this.removeClass("multiselectlist--state-enabled");
        this.setDisplay("none");
      }    
    },
    onClickSelections() {
      if (document.getElementById("app").classList.contains("multiselectlist--state-open")) {
        this.removeClass("multiselectlist--state-open");
      } else {
        this.addClass("multiselectlist--state-open");
      }
    },      
    addClass(value) {
      document.getElementById("app").classList.add(value);
    },       
    removeClass(value) {
      document.getElementById("app").classList.remove(value);
    },      
    setDisplay(value) {
      document.getElementById(this.id).style.display = value;
    },       
    onClearButton() {
      this.selections = [];

      this.removeClass("multiselectlist--state-open");
      this.updateSelectionDisplay();   
      
      this.$emit("change", this.selections);
      this.$emit("input", this.selections);            
    },   
    onAddButton() {
      if (!this.selections) {
        this.$store.commit(mutations.ADD_MESSAGE, {
          type: "error", 
          text: "There are no selections to add to the cart."
        });
  
        return;
      }

      this.$emit("submitForm");
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/css/abstract/variables";
  @import "../assets/css/abstract/mixins";
  @import "../assets/css/components/multiselectlist";

  .multiselectlist {
      display: none;
      -webkit-transition: height 0.5s;
      transition: height 0.5s;
      overflow: hidden;
      z-index: 99;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
  }

  .multiselectlist__inner {
      width: 100%;
  }       

</style>
